<!-- 基本资料 -->
 <template>
  <div class="view-container">
    <div class="hint-view">
      <img src="@/assets/image/hint-image.png" alt="" />
      <label>
        锦汇卡回收不会以任何形式公开您的个人隐私。完善个人资料，更能轻松快速销卡哦~
      </label>
    </div>
    <div class="content-view-item">
      <div class="label">用户编号</div>
      <div class="content-flex">
        <div class="content-label">{{userData.userId}}</div>
      </div>
    </div>
    <div class="content-view-item">
      <div class="label">用户昵称</div>
      <div class="content-flex">
        <div class="content-label" v-if="inputNickName">{{userData.nickName?userData.nickName:"暂未添加"}}</div>
        <div class="content-label" v-else>
          <input type="text" placeholder="请输入昵称" maxlength="20" v-model="nickName">
        </div>
        <el-button type="primary" plain  v-if="inputNickName" @click="changeNick"> {{userData.nickName?'修改':"添加"}} </el-button>
        <el-button type="primary" plain  v-else @click="submitNick"> 保存 </el-button>
      </div>
    </div>
    <div class="content-view-item">
      <div class="label">真实姓名</div>
      <div class="content-flex">
        <div style="display: flex; align-items: center">
          <div class="content-label">{{userData.name}}</div>
          <div class="auth-btn" v-if="userData.credentialLevel!=0">已实名</div>
        </div>
        <el-button type="primary" plain   v-if="userData.credentialLevel==0" @click="accountClick(5.4)">去实名</el-button>
      </div>
    </div>
    <div class="content-view-item">
      <div class="label">手机绑定</div>
      <div class="content-flex">
        <div class="content-label">{{userData.mobile}}</div>
      </div>
    </div>
  </div>
</template>

 <script>
 import http from "@/utils/http/axios";
export default {
  data() {
    return {
      inputNickName:true,//修改或者添加昵称
      nickName:'',//昵称名
      userData :undefined
    }
  },
  mounted(){
    this.getUserInfo()
  },
  methods: {

   // 0修改密码
   accountClick(vl){
        this.$emit('accountClick',vl)
      },

    // 修改昵称
    changeNick(){
      this.inputNickName=!this.inputNickName
    },
    // 保存昵称
    submitNick(){
      this.inputNickName = true;
      http
        .get("/user/update/nickName?nickName=" + this.nickName)
        .then((response) => {
          this.$message("修改成功");
          this.getUserInfo()
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });

    },
          // 获取用户信息
     getUserInfo() {
      http
        .get("/user/base/info")
        .then((response) => {
          if (response.code === 200) {
            this.userData = response.data;

          }
        })
        .catch((error) => {
          this.$message.error("发生意外异常");
        });
    },
  },
};
</script>

 <style lang="scss" scoped>
.hint-view {
  margin: 0px 30px;
  height: 40px;
  color: rgb(169, 83, 0);
  background: rgb(255, 244, 219);
  display: flex;
  align-items: center;
  font-size: 12px;
  color: rgb(169, 83, 0);
  padding: 0px 20px;
  border-radius: 10px;
  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
}
.view-container {
  background-color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 30px;

  .content-view-item {
    width: 520px;
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    border-bottom: 1px solid #e0e0e0;

    .label {
      color: rgba(0, 0, 0, 0.88);
      font-family: "PingFang SC", sans-serif;
      font-size: 16px;
      font-weight: 500;
      margin: 0px;
      flex-shrink: 0;
    }
    .sub-tip {
        box-sizing: border-box;
        color: rgba(0, 0, 0, 0.247);
        font-family: "PingFang SC", sans-serif;
        font-size: 12px;
        font-weight: 400;
        padding-left: 12px;
      }
    .content-flex {
      margin-top: 20px;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      .content-label {
        color: rgba(0, 0, 0, 0.647);
      }
      .auth-btn {
        border: 1px solid rgb(224, 224, 224);
        border-radius: 2px;
        box-sizing: border-box;
        color: rgb(136, 136, 136);
        font-size: 12px;
        font-weight: 400;
        height: 19px;
        line-height: 19px;
        margin-left: 14px;
        padding: 0px 4px;
      }

    }
  }
}
</style>
